module.exports = __webpack_public_path__ + "media/svg-new/spider-1-a797bb21.svg";